import { Form, Input } from 'antd'
import { useEffect } from 'react'

import { Button, Modal, Trans } from '@/components'
import { Machine } from '@/models/machine'

interface ConfirmationModalProps {
  open: boolean
  isCreatingIns: boolean
  machine?: Machine
  onClose: () => void
  onConfirm: (name: string) => void
}

export function ConfirmationModal({
  open,
  isCreatingIns,
  machine,
  onClose,
  onConfirm,
}: ConfirmationModalProps) {
  const [form] = Form.useForm()

  useEffect(() => {
    if (open) {
      form.resetFields()
    }
  }, [open, form])

  const handleConfirm = () => {
    form.validateFields().then((values) => {
      onConfirm(values.name)
    })
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="create.confirmModalTitle">Confirmation</Trans>
      </Modal.Header>
      <Modal.Body>
        <Form
          form={form}
          validateTrigger={['onChange', 'onBlur']}
          layout="vertical"
          name="create-instance-form"
          data-ai-component="create-instance-confirmation-form"
          data-ai-state={isCreatingIns ? 'creating' : 'ready'}
        >
          <Form.Item
            label={
              <div className="t-sb">
                <Trans i18nKey="create.form.name">Instance Name</Trans>
              </div>
            }
            id="name"
            name="name"
            className="mb-2"
          >
            <Input
              className="w-full h-11 px-4 py-3 t-sm border-neutral-200"
              placeholder={machine?.displayTitle}
              data-ai-action="enter-instance-name"
              data-ai-value={machine?.displayTitle ?? ''}
              aria-label="Instance Name"
            />
          </Form.Item>
        </Form>
        <Trans i18nKey="create.confirmModalContent">
          The time of use is calculated starting from the confirmation of the order.
        </Trans>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="outline"
          onClick={onClose}
          disabled={isCreatingIns}
          data-ai-action="cancel-create-instance"
          data-ai-state={isCreatingIns ? 'disabled' : 'enabled'}
        >
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button
          type="secondary"
          onClick={handleConfirm}
          disabled={isCreatingIns}
          data-ai-action="confirm-create-instance"
          data-ai-state={isCreatingIns ? 'creating' : 'enabled'}
        >
          <Trans i18nKey="common.confirmModalOk">Confirm</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
